import { render, staticRenderFns } from "./BuildingCard.vue?vue&type=template&id=2a203c71&scoped=true&"
import script from "./BuildingCard.vue?vue&type=script&lang=ts&"
export * from "./BuildingCard.vue?vue&type=script&lang=ts&"
import style0 from "./BuildingCard.vue?vue&type=style&index=0&id=2a203c71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a203c71",
  null
  
)

export default component.exports